import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';
import { Debounce } from 'utils/helperMethods';
import useAdministratorsLoanOfficers from 'reducers/hooks/administrators/useLoanOfficers';

import LoanOfficersList from './components/LoanOfficersList';
import Search from './components/Search';

import useStyles from './useStyles';

const INITIAL_SEARCH_FIELDS_VALUES = { name: '', company: '', companyNmls: '' };

const AdminDashboard = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    loanOfficers,
    loadLoanOfficers,
    meta,
    isLoanOfficersLoading,
    isLoanOfficersIdle,
    loadMoreLoanOfficers,
  } = useAdministratorsLoanOfficers();

  useEffect(() => {
    loadLoanOfficers(searchFieldsValues);
  }, []);

  const [searchFieldsValues, setSearchFieldsValues] = useState(INITIAL_SEARCH_FIELDS_VALUES);

  const debouncedSearchChange = Debounce(searchFields => {
    loadLoanOfficers(searchFields);
  });

  const handleSearchFieldChange = ({ target: { name, value } }) => {
    const searchValues = { ...searchFieldsValues, [name]: value };
    setSearchFieldsValues(searchValues);
    debouncedSearchChange(searchValues);
  };

  const handleLoadMore = params => {
    loadMoreLoanOfficers({ ...params, ...searchFieldsValues });
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.paper}>
        <Typography variant="h1">{t('components.AdminDashboard.header')}</Typography>
        <Search values={searchFieldsValues} onChange={handleSearchFieldChange} />
        <LoanOfficersList
          meta={meta}
          loanOfficers={loanOfficers}
          isLoading={isLoanOfficersLoading || isLoanOfficersIdle}
          onLoadMore={handleLoadMore}
        />
      </Box>
    </Box>
  );
};

export default AdminDashboard;



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/AdminDashboard.js